export type SampleSizeBand = 'strong' | 'moderate' | 'small' | 'very_small';

export function sampleSizeBand(n: number): SampleSizeBand {
  if (n >= 100) {
    return 'strong';
  }
  if (n >= 30) {
    return 'moderate';
  }
  if (n >= 10) {
    return 'small';
  }
  return 'very_small';
}

export function sampleSizeLabel(n: number): string {
  switch (sampleSizeBand(n)) {
    case 'strong':
      return 'Strong sample';
    case 'moderate':
      return 'Moderate sample';
    case 'small':
      return 'Small sample';
    case 'very_small':
      return 'Very small sample';
  }
}

export function sampleSizeNote(n: number): string {
  return `${sampleSizeLabel(n)} (n=${n.toLocaleString('en-US')}). Describes sample size only.`;
}
